/*
 * Small runtime compatibility layer for older iPhone Safari/WebKit.
 * These APIs are used by the app and are native on current iOS, but are
 * missing on several still-active Safari releases.  Keep this dependency
 * free and load it before the React app.
 */
(function installSafariCompatibility(global) {
  if (!global) return;

  if (!global.globalThis) global.globalThis = global;

  if (!Array.prototype.at) {
    Object.defineProperty(Array.prototype, 'at', {
      value: function at(index) {
        var length = this.length >>> 0;
        var position = Number(index) || 0;
        if (position < 0) position += length;
        return position < 0 || position >= length ? undefined : this[position];
      },
      configurable: true,
      writable: true,
    });
  }

  if (!String.prototype.replaceAll) {
    Object.defineProperty(String.prototype, 'replaceAll', {
      value: function replaceAll(search, replacement) {
        if (search instanceof RegExp) {
          if (!search.global) throw new TypeError('replaceAll requires a global RegExp');
          return this.replace(search, replacement);
        }
        return this.split(String(search)).join(String(replacement));
      },
      configurable: true,
      writable: true,
    });
  }

  if (!Object.fromEntries) {
    Object.fromEntries = function fromEntries(entries) {
      var result = {};
      if (!entries) return result;
      var iterator = typeof Symbol !== 'undefined' && entries[Symbol.iterator]
        ? entries[Symbol.iterator]()
        : null;
      if (iterator) {
        var next = iterator.next();
        while (!next.done) {
          var pair = next.value;
          if (pair && pair.length > 1) result[pair[0]] = pair[1];
          next = iterator.next();
        }
        return result;
      }
      for (var i = 0; i < entries.length; i += 1) {
        var entry = entries[i];
        if (entry && entry.length > 1) result[entry[0]] = entry[1];
      }
      return result;
    };
  }

  if (!Promise.allSettled) {
    Promise.allSettled = function allSettled(items) {
      return Promise.all(Array.prototype.map.call(items, function (item) {
        return Promise.resolve(item).then(
          function (value) { return { status: 'fulfilled', value: value }; },
          function (reason) { return { status: 'rejected', reason: reason }; },
        );
      }));
    };
  }

  if (!global.queueMicrotask) {
    global.queueMicrotask = function queueMicrotask(callback) {
      Promise.resolve().then(callback).catch(function (error) {
        global.setTimeout(function () { throw error; }, 0);
      });
    };
  }
}(typeof window !== 'undefined' ? window : undefined));
